import * as InitActions from '~app/actions/init';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  isLoading: false,
  loadingMessage: null,
  loadingProgressPct: null,
};

function loadingStarted(state, {message, progressPct = null}) {
  return {
    ...state,
    isLoading: true,
    loadingMessage: message,
    loadingProgressPct: progressPct,
  };
}

function loadingProgressUpdated(state, {message, progressPct = undefined}) {
  if (progressPct === undefined) {
    progressPct = state.loadingProgressPct;
  }
  return {
    ...state,
    isLoading: true,
    loadingMessage: message,
    loadingProgressPct: progressPct,
  };
}

function loadingFinished(state) {
  return {
    ...state,
    isLoading: false,
  };
}

const ACTION_HANDLERS = {
  [InitActions.LOADING_STARTED]: loadingStarted,
  [InitActions.LOADING_PROGRESS_UPDATE]: loadingProgressUpdated,
  [InitActions.LOADING_FINISHED]: loadingFinished,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/initReducer.js